<template>
  <div v-if="video1.length > 0 || userData.groupname === 'psd'">
    <div>
      <b-row>
        <b-col
          lg="6"
          md="6"
          sm="6"
        >
          <span style="color:white; text-align: left; font-size:24px;">
            <svg
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.625 3.25C2.52043 3.25 1.625 4.14543 1.625 5.25V20.75C1.625 21.8546 2.52043 22.75 3.625 22.75H22.375C23.4796 22.75 24.375 21.8546 24.375 20.75V5.25C24.375 4.14543 23.4796 3.25 22.375 3.25H3.625ZM13.8125 5.28125H11.375V9.40287H6.05476V7.23127L3.24996 10.6438L6.05476 14.0563V11.8847H11.375V20.8813H13.8125V16.7597H19.9452V18.9313L22.75 15.5188L19.9452 12.1063V14.2779H13.8125V5.28125Z"
                fill="url(#paint0_linear_751_16038)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_751_16038"
                  x1="13"
                  y1="21.3688"
                  x2="13"
                  y2="5.76875"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset="0.302083"
                    stop-color="#8246FE"
                  />
                  <stop
                    offset="1"
                    stop-color="#D2BDFD"
                  />
                </linearGradient>
              </defs>
            </svg>
            <span v-if="userData.department === '0'">ป้าย VMS (ทั่วประเทศ)</span>
            <span v-else>ป้าย VMS</span>
          </span>
        </b-col>
        <b-col
          lg="6"
          md="6"
          sm="6"
          class="text-sm-right"
        >
          <b-link
            v-if="userData.groupname !== 'psd'"
            to="/vms-total"
          >
            <span style="text-align: right; color: #00B058; font-size:20px; text-decoration: underline;">
              ดูเพิ่มเติม
            </span>
            <feather-icon
              size="30"
              icon="ChevronRightIcon"
              style="color: #00B058; margin-bottom: 3px;"
            />
          </b-link>
          <b-link
            v-if="userData.groupname === 'psd'"
            href="http://dorrayongcenter.dyndns.org:11080/"
            target="_blank"
          >
            <span style="text-align: right; color: #00B058; font-size:20px; text-decoration: underline;">
              ดูเพิ่มเติม
            </span>
            <feather-icon
              size="30"
              icon="ChevronRightIcon"
              style="color: #00B058; margin-bottom: 3px;"
            />
          </b-link>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col
        xl="12"
        lg="12"
        md="12"
        sm="12"
        xs="12"
      >
        <b-row v-if="userData.groupname !== 'psd'">
          <b-col
            v-for="(item, index) in video1.slice(0, 2)"
            :key="index"
            xl="6"
            lg="6"
            md="12"
            sm="12"
            xs="12"
          >
            <br>
            <b-card
              no-body
            >
              <video
                :id="'video1' + index"
                :src="item.video"
                style="width : 738px; height: 441px"
                muted
                autoplay
                loop
              />
              <b-card-text style="color: #ffffff;">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+1 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="userData.groupname === 'psd'">
          <b-col
            v-for="(item, index) in video1.slice(0, 2)"
            :key="index"
            xl="6"
            lg="6"
            md="12"
            sm="12"
            xs="12"
          >
            <br>
            <b-card
              no-body
            >
              <iframe
                :id="'vms' + index"
                style="height: 320px;width: 480px;overflow: hidden;"
                class="mx-auto"
                allowfullscreen
                frameBorder="0"
                :src="item.video"
              />
              <b-card-text v-if="item.connect === 'Online'">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+1 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}

              </b-card-text>
              <b-card-text v-else>
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_122_3)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_122_3"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FB9999" />
                      <stop
                        offset="0.404167"
                        stop-color="#B00000"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center"
                  >
                    <h1> {{ index+1 }}</h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="userData.groupname !== 'psd'">
          <b-col
            v-for="(item, index) in video1.slice(2, 5)"
            :key="index"
            xl="4"
            lg="4"
            md="12"
            sm="12"
            xs="12"
          >
            <br>
            <b-card
              no-body
              style="width:100%;"
            >
              <video
                :id="'video1' + index"
                :src="item.video"
                style="width:497px; height:281px;"
                muted
                playsinline
                autoplay
                loop
              />
              <b-card-text style="color: #ffffff;">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+3 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="userData.groupname === 'psd'">
          <b-col
            v-for="(item, index) in video1.slice(2, 5)"
            :key="index"
            xl="6"
            lg="6"
            md="12"
            sm="12"
            xs="12"
          >
            <br>
            <b-card
              no-body
              style="width:100%;"
            >
              <iframe
                :id="'vms1' + index"
                class="mx-auto"
                style="height: 320px;width: 480px;overflow: hidden;"
                allowfullscreen
                frameBorder="0"
                :src="item.video"
              />
              <b-card-text v-if="item.connect === 'Online'">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="overflow: auto;"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_431_10636)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_431_10636"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#99FBCA" />
                      <stop
                        offset="0.404167"
                        stop-color="#00B058"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center;"
                  >
                    <h1 style="color: #ffffff;"> {{ index+3 }} </h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}

              </b-card-text>
              <b-card-text v-else>
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="48"
                    height="48"
                    rx="4"
                    fill="url(#paint0_linear_122_3)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_122_3"
                      x1="24"
                      y1="0"
                      x2="24"
                      y2="48"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#FB9999" />
                      <stop
                        offset="0.404167"
                        stop-color="#B00000"
                      />
                    </linearGradient>
                  </defs>
                  <foreignObject
                    width="100%"
                    height="100%"
                    y="9"
                    style="text-align:center"
                  >
                    <h1> {{ index+3 }}</h1>
                  </foreignObject>
                </svg>

                {{ item.detail }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BLink, BCardText,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BLink,
    BCardText,
  },
  data() {
    return {
      video1: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getVideo()
    setInterval(() => {
      this.getVideo()
    }, 60000)
  },
  methods: {
    // VMS
    getVideo() {
      this.video1 = []
      axios
        .post('/getVMSDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.video1 = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
  /* .text2 {
  inset: 0;
  display: grid;
  place-items: left;
  color: #fff;
} */
video {
   width:100%;
   max-width:100%;
   height:auto;
}
  </style>
